import { api } from "../../lib/apiClient";

export async function registerRequest(payload) {
  const { data } = await api.post("/auth/register", payload, {
    skipAuth: true,
  });
  return data;
}

export async function loginRequest(payload) {
  const { data } = await api.post("/auth/login", payload, { skipAuth: true });
  return data;
}

/** Super-admin portal login — the server 403s non-super-admin accounts. */
export async function adminLoginRequest(payload) {
  const { data } = await api.post("/auth/admin/login", payload, {
    skipAuth: true,
  });
  return data;
}

export async function logoutRequest(refreshToken) {
  if (!refreshToken) return;
  await api.post("/auth/logout", { refreshToken }, { skipAuth: true });
}

/** Exchange a refresh token for a fresh pair + user (used by the OAuth callback). */
export async function refreshRequest(refreshToken) {
  const { data } = await api.post(
    "/auth/refresh",
    { refreshToken },
    { skipAuth: true },
  );
  return data;
}

// ---- External providers ----
export async function getAuthProviders() {
  const { data } = await api.get("/auth/providers", { skipAuth: true });
  return data; // { google: boolean }
}

// ---- Email verification ----
export async function confirmEmailVerification(token) {
  await api.post("/auth/verify-email/confirm", { token }, { skipAuth: true });
}

export async function requestEmailVerification() {
  await api.post("/auth/verify-email/request");
}

// ---- Password reset ----
export async function forgotPassword(email) {
  await api.post("/auth/password/forgot", { email }, { skipAuth: true });
}

export async function resetPassword(token, newPassword) {
  await api.post(
    "/auth/password/reset",
    { token, newPassword },
    { skipAuth: true },
  );
}

export async function changePassword(currentPassword, newPassword) {
  await api.post("/auth/password/change", { currentPassword, newPassword });
}

export async function startTwoFactorSetup() {
  const { data } = await api.post("/auth/2fa/setup/start");
  return data;
}

export async function confirmTwoFactorSetup(code) {
  const { data } = await api.post("/auth/2fa/setup/confirm", { code });
  return data;
}

export async function verifyTwoFactor(challengeToken, code) {
  const { data } = await api.post(
    "/auth/2fa/verify",
    { challengeToken, code },
    { skipAuth: true },
  );
  return data;
}

export async function disableTwoFactor(code) {
  await api.delete("/auth/2fa", { data: { code } });
}

// ---- Profile ----
export async function updateProfile(payload) {
  const { data } = await api.patch("/users/me", payload);
  return data;
}

export async function uploadAvatar(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/users/me/avatar", form);
  return data;
}

export async function removeAvatar() {
  await api.delete("/users/me/avatar");
}

export async function fetchAvatar() {
  const { data } = await api.get("/users/me/avatar", { responseType: "blob" });
  return data;
}

// ---- Sessions ----
export async function listSessions() {
  const { data } = await api.get("/auth/sessions");
  return data;
}

export const revokeSession = (id) => api.delete(`/auth/sessions/${id}`);

/** Revokes every session, this device's included. */
export const logoutEverywhere = () => api.post("/auth/logout-all");

/** Public settings for the signup page: { turnstileSiteKey } (null = bot check off). */
export async function getSignupConfig() {
  const { data } = await api.get('/auth/signup-config', { skipAuth: true });
  return data;
}
